__webpack_require__.p = "/mobile/sccpPlatform/";